import { useState, useEffect, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import "../../css/ListUsers.css";
import FetchUtil from "../../utils/FetchUtil";
import UserContext from "../../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import DelegateLocationReadOnlyRow from "../../components/DelegateLocationReadOnlyRow";
import DelegateLocationTableRow from "../../components/DelegateLocationTableRow";


function ListDelegateLocations({ indirectBuyerKey, buyerKey, partnershipKey, selectedDelegate, level, setLocation }) {
    const navigate = useNavigate();
    const [add, setAdd] = useState(false);
    const [addRowTop, setAddRowTop] = useState(false);
    const [addRowBottom, setAddRowBottom] = useState(false);
    const [edit, setEdit] = useState(false);

    const [errorValue, setErrorValue] = useState("");
    const [delegateLocations, setDelegateLocations] = useState([]);
    const [editableRecord, setEditableRecord] = useState({});
    const [count, setCount] = useState(0);
    const { t } = useTranslation();
    const userCtx = useContext(UserContext);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchDelegateLocation();
    }, []);

    const initialValues = {
        delegateLocationKey: 0,
        locationKey: 0,
        buyerKey: buyerKey,
        companyKey: 0,
        indirectBuyerKey: indirectBuyerKey,
        statusCode: 1,
        level: level,
        delegateKey: 0,
        partnershipKey: partnershipKey,
    };

    const [editFormData, setEditFormData] = useState(initialValues);

    const resetCounter = () => {
        setCount(prevCount => prevCount + 1);
    };
    function fetchDelegateLocation() {
        setErrorValue("");
        if ((!indirectBuyerKey || indirectBuyerKey === 0)) {
            setErrorValue(t("error.indirectBuyer.Reqd"));
            return;
        }
        if ((!buyerKey || buyerKey === 0)) {
            setErrorValue(t("error.buyer.Reqd"));
            return;
        }
        if ((!selectedDelegate.companyId || selectedDelegate.companyId == 0)) {
            setErrorValue(t("error.suplrReqd"));
            return;
        }
        setIsLoading(true);
        resetCounter();
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: true,
                indirectBuyerKey: indirectBuyerKey,
                buyerKey: buyerKey,
                companyKey: selectedDelegate.companyId,
                level: level,
            }),
        };
        try {
            FetchUtil.fetchAPI("GetDelegateLocations", "/Service/CompanyService/GetDelegateLocations", requestOptions, fetchDelegateLocationSuccess, fetchDelegateLocationFail);
        } catch (error) {
            setIsLoading(false);
            throw new Error(error.message);
        }
    }

    function fetchDelegateLocationFail(redirect) {
        setIsLoading(false);
        if (redirect) {
            navigate("/");
        }
        setErrorValue(t("error.delegateLocationNotRetrieved"));
    }

    function fetchDelegateLocationSuccess(responseData) {
        let getDelegateLocationResponse;
        if (responseData) {
            getDelegateLocationResponse = responseData.getDelegateLocationResponse;
            if (getDelegateLocationResponse && getDelegateLocationResponse.errorCode === "0") {
                if (getDelegateLocationResponse.delegateLocations) {
                    setDelegateLocations([...getDelegateLocationResponse.delegateLocations]);
                } else {
                    setDelegateLocations([]);
                }
            } else if (getDelegateLocationResponse && getDelegateLocationResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (getDelegateLocationResponse) {
                setErrorValue(t("error.error") + " " + getDelegateLocationResponse.errorMessage);
            } else {
                setErrorValue(t("error.system.fetch"));
            }
        }
        setIsLoading(false);
    }

    const addRowTableTop = () => {
        setAddRowTop(true);
        setAddRowBottom(false);
        addRowTable();
    };

    const addRowTableBottom = () => {
        setAddRowTop(false);
        setAddRowBottom(true);
        addRowTable();
    };

    const addRowTable = () => {
        setErrorValue("");
        if (!add && !edit) {
            setAdd(true);
        } else {
            if (add) {
                setErrorValue(t("error.only1RowAllowed"));
            } else if (edit) {
                setErrorValue(t("error.onlyEditAllowed"));
            }
        }
    };
    const removeRowTable = () => {
        setErrorValue("");
        resetRowTable();
        setIsLoading(false);
    };

    const resetRowTable = () => {
        setAddRowTop(false);
        setAddRowBottom(false);
        setAdd(false);
        setEdit(false);
    };
    const handleClose = () => {
        setErrorValue("");
        setAddRowTop(false);
        setAddRowBottom(false);
        setAdd(false);
        setEdit(false);
        setLocation(false);
    }
    const handleEditClick = (event, delegateLocationItem, completeCallback) => {
        event.preventDefault();
        setErrorValue("");
        if (!add && !edit) {
            setEdit(true);
            setEditableRecord(delegateLocationItem);
        } else {
            if (add) {
                setErrorValue(t("error.newRowAdded"));
            } else if (edit) {
                setErrorValue(t("error.onlyEditAllowed"));
            }
        }
    };
    const handleDeleteClick = (event, delegateLocationItem, completeCallback) => {
        event.preventDefault();
        setErrorValue("");
        deleteDelegateLocation(delegateLocationItem, completeCallback);
    };

    const deleteDelegateLocation = (delegateLocationItem, completeCallback) => {
        let action = 3;
        if (delegateLocationItem.statusCode === 1) {
            action = 4;
        }
        let serverParams = {
            delegateLocationKey: delegateLocationItem.delegateLocationKey,
            statusCode: delegateLocationItem.statusCode,
            source: "web",
            action: action
        };
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };
        try {
            FetchUtil.fetchAPI("DeleteDelegateLocation", "/Service/CompanyService/DeleteDelegateLocation", requestOptions, deleteDelegateLocationSuccess, deleteDelegateLocationFail, completeCallback);
        } catch (error) {
            setErrorValue(error.message);
            if (completeCallback) {
                completeCallback();
            }
        }
    }

    function deleteDelegateLocationFail(redirect, completeCallback) {
        if (redirect) {
            navigate("/");
        }
        setErrorValue(t("error.delegateLocationDeleteFailed"));
        if (completeCallback) {
            completeCallback();
        }
    }
    function deleteDelegateLocationSuccess(responseData, completeCallback) {
        let deleteDelegateLocationResponse;
        if (responseData) {
            deleteDelegateLocationResponse = responseData.deleteDelegateLocationResponse;
            if (deleteDelegateLocationResponse && deleteDelegateLocationResponse.errorCode === "0") {
                resetRowTable();
                fetchDelegateLocation();
            } else if (deleteDelegateLocationResponse && deleteDelegateLocationResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else {
                setErrorValue(t("error.error") + " " +
                    deleteDelegateLocationResponse.errorMessage
                );
            }
        }
        if (completeCallback) {
            completeCallback();
        }
    }

    const handleSubmit = (action, setValues, completeCallback) => {
        setErrorValue("");
        let found = false;
        if (action === 2) {
            editFormData.delegateLocationKey = setValues.delegateLocationKey;
        } else {
            editFormData.delegateLocationKey = 0;
        }

        editFormData.companyKey = setValues.companyKey;
        editFormData.locationKey = setValues.locationKey;
        editFormData.delegateKey = setValues.delegateKey;
        if (!editFormData.companyKey || editFormData.companyKey == 0) {
            setErrorValue(t("error.companyReqd"));
            if (completeCallback) {
                completeCallback();
            }
            return false;
        }
        if (!buyerKey || buyerKey == 0) {
            setErrorValue(t("error.buyer.Reqd"));
            if (completeCallback) {
                completeCallback();
            }
            return false;
        }
        if (!indirectBuyerKey || indirectBuyerKey == 0) {
            setErrorValue(t("error.indirect.buyer.Reqd"));
            if (completeCallback) {
                completeCallback();
            }
            return false;
        }
        if (!editFormData.locationKey || editFormData.locationKey == 0) {
            setErrorValue(t("error.location.Reqd"));
            if (completeCallback) {
                completeCallback();
            }
            return false;
        }
        if (action === 1) {
            if (delegateLocations.length > 0) {
                delegateLocations.map((delegateLocation, index) => {
                    if (delegateLocation.companyId === editFormData.companyKey
                        && delegateLocation.buyerKey === buyerKey
                        && delegateLocation.indirectBuyerKey === indirectBuyerKey
                        && delegateLocation.locationKey === editFormData.locationKey
                        && delegateLocation.delegateKey === editFormData.delegateKey) {
                        setErrorValue(t("error.delegateLocationDup"));
                        found = true;
                        if (completeCallback) {
                            completeCallback();
                        }
                        return false;
                    }
                })
            }
            if (!found) {
                saveDelegateLocation(action, completeCallback);
            }
        } else if (action === 2) {
            if (!editFormData.delegateLocationKey) {
                setErrorValue(t("error.delegateLocKey.Reqd"));
                if (completeCallback) {
                    completeCallback();
                }
                return false;
            }
            if (delegateLocations.length > 0) {
                delegateLocations.map((delegateLocation, index) => {
                    if (delegateLocation.companyId === editFormData.companyKey
                        && delegateLocation.buyerKey === buyerKey
                        && delegateLocation.indirectBuyerKey === indirectBuyerKey
                        && delegateLocation.locationKey === editFormData.locationKey
                        && delegateLocation.delegateKey === editFormData.delegateKey) {
                        if (delegateLocation.delegateLocationKey !== editFormData.delegateLocationKey) {
                            setErrorValue(t("error.delegateLocationDup"));

                        }
                        found = true;
                        if (completeCallback) {
                            completeCallback();
                        }
                        return false;
                    }
                })
            }
            if (!found) {
                saveDelegateLocation(action, completeCallback);
            }
        }
    };
    const saveDelegateLocation = (action, completeCallback) => {
        let serverParams = {
            delegateLocationKey: editFormData.delegateLocationKey,
            companyId: editFormData.companyKey,
            buyerKey: buyerKey,
            indirectBuyerKey: indirectBuyerKey,
            locationKey: editFormData.locationKey,
            delegateKey: editFormData.delegateKey,
            source: "web",
            action: action
        };
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };

        try {
            FetchUtil.fetchAPI("AddUpdateDelegateLocation", "/Service/CompanyService/AddUpdateDelegateLocation", requestOptions, saveDelegateLocationSuccess, saveDelegateLocationFail, completeCallback);
        } catch (error) {
            setErrorValue(error.message);
            if (completeCallback) {
                completeCallback();
            }
        }
    };

    function saveDelegateLocationFail(redirect, completeCallback) {
        setErrorValue(t("error.delegateLocationSaveFailed"));
        if (completeCallback) {
            completeCallback();
        }
    }
    function saveDelegateLocationSuccess(responseData, completeCallback) {
        let addUpdateDelegateLocationResponse;
        if (responseData) {
            addUpdateDelegateLocationResponse = responseData.addUpdateDelegateLocationResponse;
            if (addUpdateDelegateLocationResponse) {
                if (addUpdateDelegateLocationResponse.errorCode === "0") {
                    resetRowTable();
                    fetchDelegateLocation();
                } else if (addUpdateDelegateLocationResponse.errorCode === "114") {
                    navigate("/", {
                        state: {
                            errorMessage: t("error.sessionTimeout"),
                        },
                    });
                } else {
                    setErrorValue(t("error.error") + " " +
                        addUpdateDelegateLocationResponse.errorMessage
                    );
                }
            }
        }
        if (completeCallback) {
            completeCallback();
        }
    }
    return (
        <>
            {(userCtx.role === "SiteAdmin") ?
                <div className="modalContainer-sm hide-scrollbar">
                    <div className="row">
                        <div className="col">
                            <h5 style={{ marginLeft: "2vw", textAlign: 'center' }}><b><span style={{ fontSize: "18px" }}></span>{t("header.admin.DelegateLocation")}</b></h5>
                        </div>
                    </div>
                    <div className="row" style={{ margin: "0px" }}>
                        <div className="col">
                            <a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div
                                id="inerrorMessage"
                                className={
                                    (errorValue) ? "errorblock" : "errorblock hide"
                                }
                            >
                                {errorValue ? errorValue : ""}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div id="placeholder_1" className="placeholder-pg"></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <table className="list-table" role="table">
                                <thead>
                                    <tr role="row">
                                        <th className="list-th" style={{ maxWidth: "50vw" }}>{t("page.secondarySupplierName")}</th>
                                        <th className="list-th" style={{ minWidth: "10vw", maxWidth: "30vw" }}>{t("page.location")}</th>
                                        <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.status")}</th>
                                        <th className="list-th" style={{ maxWidth: "10vw" }}>
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
                                                {t("page.addRow")}
                                            </button>&nbsp;&nbsp;
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
                                                {t("page.delRow")}
                                            </button>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody role="rowgroup">
                                    {add && addRowTop &&
                                        <DelegateLocationTableRow
                                            index={count}
                                            selectedDelegate={selectedDelegate}
                                            primaryBuyerCompanyId={buyerKey}
                                            secondaryBuyerCompanyId={indirectBuyerKey}
                                            delegateLocationItem={{}}
                                            handleSubmit={handleSubmit}
                                            setError={setErrorValue}
                                            t={t}
                                            setAdd={setAdd}
                                            setEdit={setEdit}
                                            oddIdx={((delegateLocations.length % 2) > 0) ? true : false} />
                                    }
                                    {delegateLocations.length > 0 && (
                                        delegateLocations.map((delegateItem, index) => (
                                            ((edit && delegateItem.delegateLocationKey === editableRecord.delegateLocationKey) ?
                                                <DelegateLocationTableRow
                                                    index={count}
                                                    selectedDelegate={selectedDelegate}
                                                    primaryBuyerCompanyId={buyerKey}
                                            		secondaryBuyerCompanyId={indirectBuyerKey}
                                                    delegateLocationItem={editableRecord}
                                                    handleSubmit={handleSubmit}
                                                    setError={setErrorValue}
                                                    t={t}
                                                    setAdd={setAdd}
                                                    setEdit={setEdit}
                                                    oddIdx={((delegateLocations.length % 2) > 0) ? true : false} />
                                                :
                                                <DelegateLocationReadOnlyRow
                                                    index={count}
                                                    t={t}
                                                    delegateItem={delegateItem}
                                                    handleDeleteClick={handleDeleteClick}
                                                    handleEditClick={handleEditClick}
                                                    oddIdx={((index % 2) > 0) ? true : false}
                                                    setError={setErrorValue}
                                                />
                                            )
                                        ))
                                    )}
                                    {add && addRowBottom &&
                                        <DelegateLocationTableRow
                                            index={count}
                                            selectedDelegate={selectedDelegate}
                                            primaryBuyerCompanyId={buyerKey}
                                            secondaryBuyerCompanyId={indirectBuyerKey}
                                            delegateLocationItem={{}}
                                            handleSubmit={handleSubmit}
                                            setError={setErrorValue}
                                            t={t}
                                            setAdd={setAdd}
                                            setEdit={setEdit}
                                            oddIdx={((delegateLocations.length % 2) > 0) ? true : false} />
                                    }
                                </tbody>
                                {(delegateLocations.length > 10) ? (<tfoot>
                                    <tr role="row">
                                        <th className="list-th" style={{ maxWidth: "50vw" }}>{t("page.secondarySupplierName")}</th>
                                        <th className="list-th" style={{ minWidth: "10vw", maxWidth: "30vw" }}>{t("page.location")}</th>
                                        <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.status")}</th>
                                        <th className="list-th" style={{ maxWidth: "10vw" }}>
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
                                                {t("page.addRow")}
                                            </button>&nbsp;&nbsp;
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
                                                {t("page.delRow")}
                                            </button>
                                        </th>
                                    </tr>
                                </tfoot>
                                ) : (<></>)}
                            </table>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div
                                id="berrorMessage"
                                className={
                                    (errorValue) ? "errorblock" : "errorblock hide"
                                }
                            >
                                {errorValue ? errorValue : ""}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div id="placeholder_2" className="placeholder-pg"></div>
                        </div>
                    </div>
                    <div className="footer">
                        <input
                            type="button"
                            name="delegate-location-close"
                            id="delegate-location-close"
                            className="btn btn-secondary btn-block" data-dismiss="modal"
                            onClick={(e) => handleClose()}
                            style={{ marginTop: "10px", marginBottom: "10px" }}
                            value={t("page.close")}
                        ></input>
                    </div>
                </div>
                : null}
        </>
    );
}

export default ListDelegateLocations;